export default "__VITE_ASSET__0c5b545f__"